import React from 'react';
import {
  Box,
  Hint,
  Inscription,
  OutlinedCompleteIcon,
  RoundBlockIcon,
} from '@common-fe/common-fe';

const VerifiedIcon = () => (
  <Box margin={{ top: 'spacing2' }}>
    <Hint
      hintAlign="right"
      hintWidth={140}
      hintElement={(<OutlinedCompleteIcon color="success" />)}
    >
      <Inscription>Email is verified</Inscription>
    </Hint>
  </Box>
);

const NotVerifiedIcon = () => (
  <Box margin={{ top: 'spacing2' }}>
    <Hint
      hintAlign="right"
      hintWidth={170}
      hintElement={(<RoundBlockIcon color="danger" />)}
    >
      <Inscription>Email is not verified</Inscription>
    </Hint>
  </Box>
);

interface Props {
  isVerified?: boolean;
}

const VerificationHint: React.FC<Props> = ({ isVerified }) => isVerified ? <VerifiedIcon /> : <NotVerifiedIcon />;

export default VerificationHint;
